"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prop = exports.ApiProperty = exports.ApiPropertyOptional = exports.ExtendPick = exports.ExtendExclude = exports.ObjectId = exports.Model = void 0;
exports.index = index;
exports.Schema = Schema;
exports.applyDecorators = applyDecorators;
exports.modelOptions = modelOptions;
exports.PickType = PickType;
exports.OmitType = OmitType;
exports.PartialType = PartialType;
const utils_1 = require("./utils");
const ObjectId = utils_1.noop;
exports.ObjectId = ObjectId;
const ExtendExclude = () => {
    return class {
    };
};
exports.ExtendExclude = ExtendExclude;
const ExtendPick = () => {
    return class {
    };
};
exports.ExtendPick = ExtendPick;
const Prop = () => {
    return utils_1.noop;
};
exports.Prop = Prop;
const ApiPropertyOptional = () => {
    return utils_1.noop;
};
exports.ApiPropertyOptional = ApiPropertyOptional;
function index() {
    return utils_1.noop;
}
const ApiProperty = () => {
    return utils_1.noop;
};
exports.ApiProperty = ApiProperty;
function Schema(...args) {
    return utils_1.noop;
}
function applyDecorators(...args) {
    return utils_1.noop;
}
class Model {
}
exports.Model = Model;
function modelOptions() {
    return utils_1.noop;
}
function PickType() {
    return class {
    };
}
function OmitType() {
    return class {
    };
}
function PartialType() {
    return class {
    };
}
